export default __webpack_public_path__ + "static/media/roadmap_3.25f89d2a.jpg";